module.exports = __webpack_public_path__ + "media/images/shape-bg-2-2b15ca0a27cff5a6ec5d988c74d0a987.png";